import { MutationsCreator } from '@/store/utils';

export default MutationsCreator([
  {
    name: 'GET_NEWS',
    state: 'getNews'
  }
]);
